<template>

  <div
      v-if="(type !== 'start' && started)"
      :class="classMsg"
  >
    <!-- DASHBOARDS-->
    <div v-if="options && options.piecharts && options.piecharts.length > 0" class=" chat-receiver">
      <div class="chat-msg ">
        <p v-if="userSettings.chatbot.language.current.locale === 'it'">
          Per visualizzare i risultati su un grafico clicca
          <span
              style="background-color: #0548b5; border-color: #0548b5; color: #F5F5F5; border-radius:16px; padding: 0 12px; "><button
              @click="showDashboard=!showDashboard">qui</button></span>
        </p>
        <p v-else>
          To visualize the search results on a chart click
          <span
              style="background-color: #0548b5; border-color: #0548b5; color: #F5F5F5; border-radius:16px; padding: 0 12px; "><button
              @click="showDashboard=!showDashboard">here</button></span>
        </p>

      </div>
    </div>
    <div v-show="showDashboard" v-if="options && options.piecharts && options.piecharts.length > 0"
         class="chart-container">
      <div class="choose-options" v-for="item in options.piecharts">
        <PieChart :items="item"></PieChart>
      </div>
    </div>
    <!-- META MESSAGE: control UI and chat service information -->
    <div v-if="type === 'meta'">
      <div v-if="options.type === 'divider'">
        <Divider margin="20px 0 0 0"></Divider>
        <p class="text-xs-center">{{ text }}</p>
      </div>
      <v-btn v-if="options.type === 'button'" @click="options.buttonCallback" outline color="indigo">{{ text }}
      </v-btn>
    </div>

    <!-- NORMAL MESSAGE: text and buttons -->
    <div v-else class="chat-msg">
      <preview-link
          v-if="options && options.preview"
          :options="options"
      ></preview-link>
      <video-container
          v-if="options && options.video"
          :url="options.video"
          :hastext="text"
      ></video-container>
      <div v-if="options && options.image"
           class="image-box"
           :class="{'has-text-after':text}">
        <a :href="options.link" target="_blank">
          <img :src="options.image" alt="options.image">
        </a>
      </div>
      <div v-if="options && options.buttonurl" class="logo-msg">
        <a :href="options.buttonurl.link.url" target="_blank">
          <img class="logo-white"
               :src="options.buttonurl.img"
               alt="ho-icon"
               title="ho-icon">
        </a>
      </div>
      <h2 v-if="options && options.buttonurl"
          class="content-heading">
        {{ options.buttonurl.title }}
      </h2>
      <p v-if="text" v-html="text"></p>
      <audio v-if="options && options.audio"
             class="audio-box"
             controls="" :src="options.audio"></audio>
      <a v-if="options && options.buttonurl"
         class="mob-link"
         :href="options.buttonurl.link.url"
         target="_blank">
        {{ options.buttonurl.link.text }}
      </a>
    </div>
    <!-- NORMAL MESSAGE: cards -->
    <div v-if="options && options.cards && options.cards.length > 0"
         class="cards-container"
         @wheel="scrollH">
      <cards v-for="card in options.cards"
             :data="card"
             :callback="callback">
      </cards>
    </div>

    <div class="chat-sending" :class="classMsg">
      Sending...
    </div>
    <ul v-if="options && options.links && options.links.length > 0"
        class="offer-link">
      <li v-for="item in options.links"
          :key="item.url">
        <a @click="callback(item)">{{ item.text }}</a>
      </li>
    </ul>
    <!-- NORMAL MESSAGE: options -->
    <div v-if="options && options.buttons && options.buttons.length > 0 && userChatbotSettings.buttons"
         class="options-container">

      <v-card class="elevation-0" color="transparent">
        <v-window v-model="step">
            <v-window-item :class="Math.ceil(options.buttons.length/numButtonsPerWindow)>1?'options-window':''" v-for="n in Math.ceil(options.buttons.length/numButtonsPerWindow)" v-bind:key="n">
              <div class="choose-options">
                                        <button v-for="item in filteredButtons(n)"
                                                v-bind:key="item.url"
                                                :class="item.type=== 'special' ? 'specialButton' : 'primary'"
                                                :disabled="item.disable"
                                                @click="callback(item)">

                                            {{ item.text }}
                                        </button>
            </div>
          </v-window-item>
        </v-window>
        <v-card-actions v-if="Math.ceil(options.buttons.length/numButtonsPerWindow)>1"
                        class="justify-center options-pagination">
          <v-btn :disabled="step===0" icon @click="step--">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn :disabled="step === Math.round(options.buttons.length/numButtonsPerWindow)" icon @click="step++">
            <v-icon>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

    </div>
    <div v-if="options && options.files && options.files.length > 0"
         class="options-container">
      <div class="choose-options" style="flex-direction: row;">
        <a
            v-for="file in options.files"
            target="_blank"
            @click="downloadFile(file.filename, file.version)"
        >
          <img
              class="documents"
              :src="require('../../assets/img/files/png/' + file.image)"
              :title="file.filename"
          >
        </a>
      </div>
    </div>
    <div
        v-if="options && options.images && options.images.length > 0"
        class="options-container"
    >
      <div class="choose-options">
        <a
            v-for="item in options.images"
            :href="item.location"
            target="_blank"
        >
          <img
              class="imagePreview"
              :src="item.image"
              :title="item.title"
          >
        </a>
      </div>
    </div>

  </div>
  <!-- LOADING MESSAGE -->
  <div
      v-else-if="(type === 'loader' && type !== 'start')"
      class="chat-receiver padding-top"
  >
    <img
        class="bounce"
        src="../../assets/img/chatbot/loader.png"
        alt="none"
    >
    <img
        class="bounce delay-2"
        src="../../assets/img/chatbot/loader.png"
        alt="none"
    >
    <img
        class="bounce delay-4"
        src="../../assets/img/chatbot/loader.png"
        alt="none"
    >
  </div>
  <!-- SPLASH MESSAGE -->
  <div v-else-if="(type !== 'loader' && type === 'start' && !started)"
       class="chat-splash">
    <img
        class="chat-splash__logo"
        src="../../assets/img/chatbot/whitelabel/logo-splash.png"
        srcset="../../assets/img/chatbot/whitelabel/logo-splash@2x.png 2x, @/assets/img/chatbot/whitelabel/logo-splash@3x.png 3x"
    >
    <p>{{ text }}</p>
    <a
        v-for="item in options.links"
        :key="item.url"
        @click="callback(item)"
    >{{ item.text }}</a>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

import UrlsService from "@/helpers/UrlsService.js";
import APIService from "@/helpers/APIService.js";
import TextService from "@/helpers/TextService.js";
import TimeService from "@/helpers/TimeService.js";

import VideoContainer from "./VideoContainer.vue";
import PreviewLink from "./PreviewLink.vue";
import Cards from "./Cards.vue";

import {vm,} from "../../main.js";
import Divider from "../Decorator/Divider";
import PieChart from "@/components/Dashboards/PieChart";


export default {
  name: "Message",
  components: {
    Divider,
    VideoContainer,
    PreviewLink,
    Cards,
    PieChart
  },
  props: ["text", "type", "options", "callback", "started", "messagesCount", "messagesIndex", "parent",],
  data() {
    return {
      numButtonsPerWindow: 10,
      step: 0,
      id: "",
      showDashboard: false
    };
  },
  computed: {
    classMsg() {
      return {
        "chat-splash": this.type === "start",
        "chat-sender": this.type === "request",
        "chat-receiver": this.type === "response",
        "chat-meta-message": this.type === "meta",
        "chat-has-options": this.options && this.options.links && this.options.links.length > 0,
        "four-side-border": this.options && this.options.buttonurl,
      };
    },
    ...mapGetters("UserState", {
          userOptions: "getUserOptions",
          userSettings: "getSettings",
        },
    ),
    ...mapGetters("AppState", {
          userChatbotSettings: "getSettings",
        },
    ),
  },
  mounted() {
    this.$nextTick(function () {
      if (this._vnode.data && this._vnode.data.class && this._vnode.data.class["chat-receiver"]) {
        if (this._props.messagesIndex === this._props.messagesCount) {
          vm.$emit("renderedAllMessage");
        }
      }
    });
  },
  created() {
    this.id = TextService.generateRandomString(16);
  },
  methods: {
    filteredButtons(n){
      let temp = [];
      for (let i=0; i<this.options.buttons.length; i++){
        if(i >= (n-1)*this.numButtonsPerWindow && i < (n)*this.numButtonsPerWindow){
          // if(this.options.buttons[i].text!==""&&this.options.buttons[i].textToSend!=="")
            temp.push(this.options.buttons[i])
        }
      }

      return temp;
    },
    getFileImage(file) {
      let string = "../../assets/img/files/png" + file.image;
      string = require("../../assets/img/files/png" + file.image);
      return string;
    },
    downloadFile(filename, version) {
      let requestUrl = {
        url: UrlsService.getFileDownload,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          elasticSearchRequest: {},
        },
        additionalData: {
          filename: filename,
          version: version.toString(),
        },
      };
      APIService.download(requestUrl, requestData)
          .then(responseSuccess => {
            let response = responseSuccess;
            let newBlob = new Blob([response,], {type: "application/octet-stream",});
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
          });
    },

    is_touch_device() {
      return (("ontouchstart" in window)
          || (navigator.MaxTouchPoints > 0)
          || (navigator.msMaxTouchPoints > 0));
    },
    scrollH(e) {
      if (e.wheelDeltaY !== 0 && (Math.abs(e.wheelDeltaY) > Math.abs(e.wheelDeltaX)) && !this.is_touch_device()) {
        let d = e.wheelDeltaY;
        // remove higher or lower numbers
        d = (d > 60) ? 60 : (d < -60) ? -60 : d;

        let ct = e.currentTarget;
        let parentTarget = ct.parentElement.parentElement.parentElement;
        let mustScrollH = (parentTarget.scrollTop > 280);

        if (mustScrollH) {
          ct.scrollLeft += d * -1;
          if ((ct.scrollLeft + ct.clientWidth !== ct.scrollWidth) && (ct.scrollLeft !== 0)) {
            e.stopPropagation();
          }
        }
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/scss/chatbot/commons";

$accentColor: #0071dd; // blue / #54bc54 --> light green
$linkColor: #cee1ff; // icelightblue
$botAccentColor: #385870; // blue / #54bc54 --> light green
$messageMaxWidth: 500px;

// Initial button
.chat-splash {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  height: 100%;
  @include e('logo') {
    width: 118px;
    margin: 0 auto;
    display: block;
  }

  p {
    color: #878787;
    font-size: 29px;
    margin: 30px 0;
  }

  a {
    display: block;
    width: 160px;
    margin: 0 auto;
    line-height: 49px;
    text-transform: uppercase;
    height: 49px;
    border-radius: 1.9em;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    font-family: $font-book;
    @include gradient(background, linear, (45deg, #165421 0%, #52ea73 100%));
  }
}

.chat-sending {
  display: none;

  &.chat-sender {
    display: block;
    margin: 5px 0 20px;
    color: #999;
    font-size: 14px;
    opacity: 1;
    animation: fadeOut .25s ease-in-out;
    animation-fill-mode: forwards;
    animation-delay: 1s;
  }
}

.cards-container {
  padding: 10px 0;
  display: flex;
  overflow: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
}
.chart-container {
  align-content: start;
  margin-left: -100px;
  display: flex;
  overflow: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
}

// AI BOT: Classic Message
.chat-msg {
  border-radius: 25px 25px 25px 5px;
  padding: 14px;
  max-width: $messageMaxWidth;
  width: auto;
  background-color: #f2f5fa; // grey
  border: 1px solid #f2f5fa;
  display: inline-block;
  box-sizing: border-box;

  p {
    margin-bottom: 0 !important;
    line-height: 22px;
    font-size: 16px;
    color: #37383c; // AI BOT: text color
    font-family: $font-book;
    word-wrap: break-word;

    strong {
      font-family: $font-medium;
    }

    img {
      max-width: 100%;
    }
  }

  // USER: Classic Message
  .chat-sender & {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 25px;
    background-color: $accentColor; // light green
    display: inline-block;
    width: auto;

    p {
      color: #fff; // text
      text-align: left;
    }
  }

  .four-side-border & {
    border-bottom-left-radius: 25px;
    padding: 0;

    p {
      font-size: 13px;
      font-family: $font-book;
      color: #666;
      margin: 0 12px;
      line-height: 18px;
    }
  }

  .chat-splash & {
    background: transparent;
    border: none;
    display: block;
    margin: 0 auto;
  }
}

.chat-sender, .chat-receiver {
  margin: 10px 0 10px;
  opacity: 0;
  animation: slideInFromBottom 0.3s forwards ease-in-out;
  animation-delay: .3s;
}

.chat-sender {
  text-align: right;
}

.chat-receiver {
  + .chat-receiver {
    margin-top: -8px;

    .chat-msg {
      border-radius: 5px 25px 25px 5px;
    }

    &.padding-top {
      margin-top: -10px;
    }
  }

  &.hasChatMsg {
    .offer-box {
      border-radius: 25px 25px 0 0;
    }

    .chat-msg {
      border-radius: 0;
    }

    &.chat-has-options {
      .chat-msg {
        width: 100%;
        border-radius: 0;
      }
    }
  }

  &.chat-has-options {
    .offer-link {
      border-radius: 0 0 25px 5px;
    }

    .chat-msg {
      width: 100%;
      border-radius: 25px 25px 0 0;
    }
  }
}

.offer-link {
  width: $messageMaxWidth;
  padding: 0;
  margin: 0;
  list-style: none;
  background-color: $linkColor;
  border-radius: 5px 25px 25px 5px;
  border: 1px solid #f2f5fa;

  li {
    a {
      display: block;
      padding: 13px 16px;
      font-size: 16px;
      font-family: $font-book;
      text-align: center;
      color: $accentColor; // link text color
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      border-bottom: 1px solid #f2f5fa;
      word-wrap: break-word;

      &::first-letter {
        text-transform: capitalize;
      }
    }

    &:last-child {
      a {
        border-bottom: 0 none;
      }
    }
  }
}

.options-container {
  max-width: 500px;
  margin: 14px 25px;
  overflow: auto;

  .options-pagination {
    padding-right: 0;
  }

  .options-window {
    min-height: 400px;
  }

  .choose-options {
    display: flex;
    flex-direction: column; // before was row
    justify-content: flex-start;
    padding-right: 0;

    .primary {
      padding: 0 15px;
      height: 38px;
      border-radius: 1.9em;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      font-family: $font-book;
      border: none;
      @include gradient(background, linear, (45deg, $botAccentColor 0%, $botAccentColor 100%));
      margin: 1px 0 1px 0;
      outline: none;

      &::first-letter {
        text-transform: capitalize;
      }
    }

    .specialButton {
      padding: 0 15px;
      height: 38px;
      border-radius: 1.9em;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      font-family: $font-book;
      border: none;
      background-color: #bc0300;
      margin: 1px 0 1px 0;
      outline: none;


      &::first-letter {
        text-transform: capitalize;
      }
    }
  }
}


.image-box {
  max-width: 500px;
  margin: -17px;
  border-radius: 25px 25px 25px 5px;
  overflow: hidden;

  &.has-text-after {
    margin-bottom: 15px;
    border-radius: 25px 25px 0 0;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.documents {
  height: 50px;
  cursor: pointer;
}

.imagePreview {
  width: 200px;
  background-color: white;
  border: 1px solid #DDD;
  padding: 2px;
  cursor: pointer;
}

.video-box {
  + .image-box {
    border-radius: 0;

    &.has-text-after {
      border-radius: 0;
    }
  }
}

.audio-box {
  margin-top: 10px;
}

.bounce {
  //-webkit-animation-name: bounce;
  animation-name: bounce;
  //-webkit-transform-origin: center bottom;
  transform-origin: center bottom;
  width: 1.5% !important;
  height: 1.5% !important;
  margin: 0 2px;
  //-webkit-animation-duration: 1.5s;
  animation-duration: 1.5s;
  //-webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  //-webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;

  &.delay-2 {
    //-webkit-animation-delay: .25s;
    animation-delay: .25s;
  }

  &.delay-4 {
    //-webkit-animation-delay: .5s;
    animation-delay: .5s;
  }
}
</style>
